export const adsBannersReducer = (state = {}, action) => {
  switch (action.type) {
    case "GET_ADS_LIST_REQUEST": {
      return {
        loading: true,
        adsBanners: null,
      };
    }
    case "GET_ADS_LIST_SUCCESS": {
      return {
        loading: false,
        adsBanners: action.payload,
      };
    }
    case "GET_ADS_LIST_FAILED": {
      return {
        loading: false,
        adsBanners: action.payload,
      };
    }
    case "ADD_ADS_REQUEST": {
      return {
        loading: true,
        adsBanners: null,
      };
    }
    case "ADD_ADS_SUCCESS": {
      return {
        loading: false,
        adsBanners: action.payload,
      };
    }
    case "ADD_ADS_FAILED": {
      return {
        loading: false,
        adsBanners: action.payload,
      };
    }
    default:
      return state;
  }
};
